import axios from 'axios'
//判断是否是本地开发环境，这样上线就不用更改，不了解，可以直接写
const host = "http://localhost:8001"
axios.defaults.withCredentials = true //开启后服务器才能拿到cookie
axios.defaults.crossDomain = true;//配置axios跨域
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8'//配置默认请求头
// axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*"
const ajax = axios.create({
    basURL:host,
    timeout: 6000,//请求超时时间
})

ajax.interceptors.request.use((req)=>{
    //请求拦截下的数据，可以添加自己的处理和操作
    //比如添加loading效果
    return req
})

ajax.interceptors.response.use((res)=>{
    //响应拦截下的数据，可以添加自己的处理和操作
    //比如添加loading效果或者
    return res.data
})
export default ajax  //最后导出



// WEBPACK FOOTER //
// ./src/utils/request.js